import React, { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../../../../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { updateProfile } from 'firebase/auth';
import {
  Box, Button, Flex, FormLabel, Select,
  SimpleGrid, Stack, Text, useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import InputField from 'components/fields/InputField';

export default function NewUser() {
  const toast     = useToast();
  const navigate  = useNavigate();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName]  = useState('');
  const [address,   setAddress]   = useState('');
  const [telefone,  setTelefone]  = useState('');
  const [role,      setRole]      = useState('');
  const [loading,   setLoading]   = useState(false);

  const VALID_ROLES = ['tecnico', 'cliente'];

  const handleSubmit = async () => {
    if (!firstName || !lastName || !VALID_ROLES.includes(role)) {
      toast({
        title: 'Preencha todos os campos obrigatórios.',
        description: !VALID_ROLES.includes(role) ? 'Selecione um perfil de acesso.' : undefined,
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const user = auth.currentUser;
    if (!user) return;

    const displayName = `${firstName} ${lastName}`;
    setLoading(true);

    try {
      // Atualiza Firebase Auth para que user.displayName fique correto em toda a app
      await updateProfile(user, { displayName });

      await setDoc(doc(db, 'users', user.uid), {
        firstName,
        lastName,
        displayName,
        email: user.email,
        address,
        telefone,
        role,
        createdAt: new Date().toISOString(),
      }, { merge: true });

      toast({
        title: 'Perfil salvo com sucesso!',
        description: 'Faca login novamente para acessar o sistema.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      await auth.signOut();
      navigate('/auth/sign-in/default');
    } catch (error) {
      toast({
        title: 'Erro ao salvar perfil',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      justify="center"
      p={{ base: '20px', md: '40px' }}
    >
      <Card maxW="600px" w="100%" p={{ base: '24px', md: '40px' }}>
        <Text fontSize="2xl" fontWeight="bold" color={textColor} mb="4px">
          Complete seu perfil
        </Text>
        <Text fontSize="sm" color="gray.500" mb="28px">
          Preencha os dados abaixo para acessar o sistema.
        </Text>

        <Stack spacing="16px">
          <SimpleGrid columns={{ base: 1, sm: 2 }} gap="16px">
            <InputField
              label="Nome *"
              placeholder="Ex: Carlos"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <InputField
              label="Sobrenome *"
              placeholder="Ex: Silva"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </SimpleGrid>

          <InputField
            label="Telefone"
            placeholder="(11) 99999-9999"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
          />

          <InputField
            label="Endereco"
            placeholder="Rua, numero, cidade..."
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />

          <Box>
            <FormLabel fontSize="sm" fontWeight="500" color={textColor} mb="6px">
              Perfil de acesso *
            </FormLabel>
            <Select
              placeholder="Selecione seu perfil"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              borderRadius="10px"
            >
              <option value="tecnico">Tecnico</option>
              <option value="cliente">Cliente</option>
            </Select>
          </Box>

          <Button
            colorScheme="brand"
            w="100%"
            h="48px"
            borderRadius="12px"
            fontSize="md"
            fontWeight="600"
            isLoading={loading}
            onClick={handleSubmit}
            mt="8px"
          >
            Salvar e entrar
          </Button>
        </Stack>
      </Card>
    </Flex>
  );
}